import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  EXTERNAL_LETTERS_LIST,
  EXTERNAL_LETTER_COMMENT_TEMPLATES,
  EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE,
  EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE,
  EXTERNAL_LETTER_COMPLETE,
  EXTERNAL_LETTER_COMPLETE_EXECUTION,
  EXTERNAL_LETTER_CONFIRM_INFORMED,
  EXTERNAL_LETTER_DELETE,
  EXTERNAL_LETTER_ITEM,
  EXTERNAL_LETTER_PROVIDE_RESOLUTION,
  EXTERNAL_LETTER_REQUIRE_UPDATE,
  EXTERNAL_LETTER_SEND_TO_INFORM,
  GLOBAL_STATE,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const LETTERS = GLOBAL_STATE

export const { reducer: letterReducer } = createSlice({
  name: LETTERS,
  initialState,
  reducers: {},
  extraReducers(builder) {
    // Legacy incoming/outgoing reducers are disabled with the /letter/* API.

    builder
      .addCase(actionCreators.externalLettersList.pending, state => {
        state[EXTERNAL_LETTERS_LIST].loading = true
      })
      .addCase(actionCreators.externalLettersList.rejected, (state, action) => {
        state[EXTERNAL_LETTERS_LIST].loading = false
        state[EXTERNAL_LETTERS_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.externalLettersList.fulfilled, (state, action) => {
        state[EXTERNAL_LETTERS_LIST].loading = false
        state[EXTERNAL_LETTERS_LIST].error = null
        state[EXTERNAL_LETTERS_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.externalLetterItem.pending, state => {
        state[EXTERNAL_LETTER_ITEM].loading = true
      })
      .addCase(actionCreators.externalLetterItem.rejected, (state, action) => {
        state[EXTERNAL_LETTER_ITEM].loading = false
        state[EXTERNAL_LETTER_ITEM].error = action.payload as AxiosError
      })
      .addCase(actionCreators.externalLetterItem.fulfilled, (state, action) => {
        state[EXTERNAL_LETTER_ITEM].loading = false
        state[EXTERNAL_LETTER_ITEM].error = null
        state[EXTERNAL_LETTER_ITEM].data = action.payload
      })

    builder
      .addCase(actionCreators.externalLetterDelete.pending, state => {
        state[EXTERNAL_LETTER_DELETE].loading = true
      })
      .addCase(actionCreators.externalLetterDelete.rejected, (state, action) => {
        state[EXTERNAL_LETTER_DELETE].loading = false
        state[EXTERNAL_LETTER_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.externalLetterDelete.fulfilled, (state, action) => {
        state[EXTERNAL_LETTER_DELETE].loading = false
        state[EXTERNAL_LETTER_DELETE].error = null
        state[EXTERNAL_LETTER_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.externalLetterCommentTemplates.pending, state => {
        state[EXTERNAL_LETTER_COMMENT_TEMPLATES].loading = true
      })
      .addCase(actionCreators.externalLetterCommentTemplates.rejected, (state, action) => {
        state[EXTERNAL_LETTER_COMMENT_TEMPLATES].loading = false
        state[EXTERNAL_LETTER_COMMENT_TEMPLATES].error = action.payload as AxiosError
      })
      .addCase(actionCreators.externalLetterCommentTemplates.fulfilled, (state, action) => {
        state[EXTERNAL_LETTER_COMMENT_TEMPLATES].loading = false
        state[EXTERNAL_LETTER_COMMENT_TEMPLATES].error = null
        state[EXTERNAL_LETTER_COMMENT_TEMPLATES].data = action.payload
      })

    builder
      .addCase(actionCreators.externalLetterCommentTemplateCreate.pending, state => {
        state[EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE].loading = true
      })
      .addCase(actionCreators.externalLetterCommentTemplateCreate.rejected, (state, action) => {
        state[EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE].loading = false
        state[EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.externalLetterCommentTemplateCreate.fulfilled, (state, action) => {
        state[EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE].loading = false
        state[EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE].error = null
        state[EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.externalLetterCommentTemplateDelete.pending, state => {
        state[EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE].loading = true
      })
      .addCase(actionCreators.externalLetterCommentTemplateDelete.rejected, (state, action) => {
        state[EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE].loading = false
        state[EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.externalLetterCommentTemplateDelete.fulfilled, (state, action) => {
        state[EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE].loading = false
        state[EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE].error = null
        state[EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.externalLetterSendToInform.pending, state => {
        state[EXTERNAL_LETTER_SEND_TO_INFORM].loading = true
      })
      .addCase(actionCreators.externalLetterSendToInform.rejected, (state, action) => {
        state[EXTERNAL_LETTER_SEND_TO_INFORM].loading = false
        state[EXTERNAL_LETTER_SEND_TO_INFORM].error = action.payload as AxiosError
      })
      .addCase(actionCreators.externalLetterSendToInform.fulfilled, (state, action) => {
        state[EXTERNAL_LETTER_SEND_TO_INFORM].loading = false
        state[EXTERNAL_LETTER_SEND_TO_INFORM].error = null
        state[EXTERNAL_LETTER_SEND_TO_INFORM].data = action.payload
        state[EXTERNAL_LETTER_ITEM].data = action.payload
      })

    builder
      .addCase(actionCreators.externalLetterProvideResolution.pending, state => {
        state[EXTERNAL_LETTER_PROVIDE_RESOLUTION].loading = true
      })
      .addCase(actionCreators.externalLetterProvideResolution.rejected, (state, action) => {
        state[EXTERNAL_LETTER_PROVIDE_RESOLUTION].loading = false
        state[EXTERNAL_LETTER_PROVIDE_RESOLUTION].error = action.payload as AxiosError
      })
      .addCase(actionCreators.externalLetterProvideResolution.fulfilled, (state, action) => {
        state[EXTERNAL_LETTER_PROVIDE_RESOLUTION].loading = false
        state[EXTERNAL_LETTER_PROVIDE_RESOLUTION].error = null
        state[EXTERNAL_LETTER_PROVIDE_RESOLUTION].data = action.payload
        state[EXTERNAL_LETTER_ITEM].data = action.payload
      })

    builder
      .addCase(actionCreators.externalLetterConfirmInformed.pending, state => {
        state[EXTERNAL_LETTER_CONFIRM_INFORMED].loading = true
      })
      .addCase(actionCreators.externalLetterConfirmInformed.rejected, (state, action) => {
        state[EXTERNAL_LETTER_CONFIRM_INFORMED].loading = false
        state[EXTERNAL_LETTER_CONFIRM_INFORMED].error = action.payload as AxiosError
      })
      .addCase(actionCreators.externalLetterConfirmInformed.fulfilled, (state, action) => {
        state[EXTERNAL_LETTER_CONFIRM_INFORMED].loading = false
        state[EXTERNAL_LETTER_CONFIRM_INFORMED].error = null
        state[EXTERNAL_LETTER_CONFIRM_INFORMED].data = action.payload
        state[EXTERNAL_LETTER_ITEM].data = action.payload
      })

    builder
      .addCase(actionCreators.externalLetterCompleteExecution.pending, state => {
        state[EXTERNAL_LETTER_COMPLETE_EXECUTION].loading = true
      })
      .addCase(actionCreators.externalLetterCompleteExecution.rejected, (state, action) => {
        state[EXTERNAL_LETTER_COMPLETE_EXECUTION].loading = false
        state[EXTERNAL_LETTER_COMPLETE_EXECUTION].error = action.payload as AxiosError
      })
      .addCase(actionCreators.externalLetterCompleteExecution.fulfilled, (state, action) => {
        state[EXTERNAL_LETTER_COMPLETE_EXECUTION].loading = false
        state[EXTERNAL_LETTER_COMPLETE_EXECUTION].error = null
        state[EXTERNAL_LETTER_COMPLETE_EXECUTION].data = action.payload
        state[EXTERNAL_LETTER_ITEM].data = action.payload
      })

    builder
      .addCase(actionCreators.externalLetterRequireUpdate.pending, state => {
        state[EXTERNAL_LETTER_REQUIRE_UPDATE].loading = true
      })
      .addCase(actionCreators.externalLetterRequireUpdate.rejected, (state, action) => {
        state[EXTERNAL_LETTER_REQUIRE_UPDATE].loading = false
        state[EXTERNAL_LETTER_REQUIRE_UPDATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.externalLetterRequireUpdate.fulfilled, (state, action) => {
        state[EXTERNAL_LETTER_REQUIRE_UPDATE].loading = false
        state[EXTERNAL_LETTER_REQUIRE_UPDATE].error = null
        state[EXTERNAL_LETTER_REQUIRE_UPDATE].data = action.payload
        state[EXTERNAL_LETTER_ITEM].data = action.payload
      })

    builder
      .addCase(actionCreators.externalLetterComplete.pending, state => {
        state[EXTERNAL_LETTER_COMPLETE].loading = true
      })
      .addCase(actionCreators.externalLetterComplete.rejected, (state, action) => {
        state[EXTERNAL_LETTER_COMPLETE].loading = false
        state[EXTERNAL_LETTER_COMPLETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.externalLetterComplete.fulfilled, (state, action) => {
        state[EXTERNAL_LETTER_COMPLETE].loading = false
        state[EXTERNAL_LETTER_COMPLETE].error = null
        state[EXTERNAL_LETTER_COMPLETE].data = action.payload
        state[EXTERNAL_LETTER_ITEM].data = action.payload
      })

    builder.addCase(actionCreators.externalLettersListClear, state => {
      state[EXTERNAL_LETTERS_LIST] = defaultState()
    })

    builder.addCase(actionCreators.externalLetterItemClear, state => {
      state[EXTERNAL_LETTER_ITEM] = defaultState()
    })

    builder.addCase(actionCreators.externalLetterCommentTemplatesClear, state => {
      state[EXTERNAL_LETTER_COMMENT_TEMPLATES] = defaultState()
    })
  },
})
